module.exports = __webpack_public_path__ + "static/media/CTLA_3-178w.d51063e2.webp";